import { ReconciliationTable } from './ReconciliationTable';

export default ReconciliationTable;
